export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.a-casa.md',
  ENDPOINTS: {
    LOGIN: '/auth/login',
    SYNC_LOGS: '/logs',
    DATE_RANGE: '/logs/date-range',
    LOGS_INFO: '/logs/sync-logs-info',
    SYNC: '/sync'
  }
};

export const getApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
}; 
